import { Fragment } from 'react';

// React escapes all plain text; only explicitly allowed URL schemes become links.
export default function LinkedText({ text = '' }) {
  const parts = String(text).split(/((?:https?:\/\/|www\.)[^\s<>]+)/gi);
  return parts.map((part, index) => {
    if (!/^(https?:\/\/|www\.)/i.test(part)) return <Fragment key={index}>{part}</Fragment>;
    const tail = part.match(/[.,;!?)]*$/)?.[0] || '', url = tail ? part.slice(0, -tail.length) : part;
    return <Fragment key={index}><a href={/^www\./i.test(url) ? 'https://' + url : url} target="_blank" rel="noopener noreferrer" onClick={e => e.stopPropagation()} onDoubleClick={e => e.stopPropagation()}>{url}</a>{tail}</Fragment>;
  });
}
